/**
 * 主题切换器组件
 * 简化版：点击直接切换亮色/暗色
 */
import React from 'react';
import { Button, Tooltip } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeSwitcher.css';

const ThemeSwitcher = () => {
  const { isDark, toggleTheme } = useTheme();
  
  return (
    <Tooltip title={isDark ? '切换到亮色模式' : '切换到暗色模式'} placement="bottom">
      <Button
        type="text"
        className="theme-switcher-btn"
        onClick={toggleTheme}
        icon={
          <span className="theme-icon-wrapper" key={isDark ? 'dark' : 'light'}>
            {isDark ? <SunOutlined /> : <MoonOutlined />}
          </span>
        }
        aria-label={isDark ? '切换到亮色模式' : '切换到暗色模式'}
      />
    </Tooltip>
  );
};

export default ThemeSwitcher;
